import { render, staticRenderFns } from "./ElectricalMaintenanceResolution.vue?vue&type=template&id=131ac81e"
import script from "./ElectricalMaintenanceResolution.vue?vue&type=script&lang=js"
export * from "./ElectricalMaintenanceResolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports